import { IStudioInfo } from './studio';

export type StaffInfo = {
  id: number;
  avatar: string;
  username: string;
  mobile: string;
  wx_number: string;
  status: number;
  role_id: number;
  store_id_arr: number[];
  store_info_arr: IStudioInfo[];
  last_login_time: string; // 最后登录时间
  mp_subscribe_status: MpSubscribeStatus; // 已关注服务号
};

// 已关注服务号
export enum MpSubscribeStatus {
  SUBSCRIBED = 1, // 已关注
  UNSUBSCRIBED = 2, // 未关注
}

// 员工角色
export enum StaffRole {
  ADMIN = 1, // 管理员
  MANAGER = 2, // 店长
  EMPLOYEE = 3, // 员工
}

// 角色信息
export type RoleInfo = {
  id: number;
  name: string;
};

// 业绩归属角色类型
export enum PerformanceRoleType {
  Staff = 1,
  Teacher = 2,
}

// 业绩归属信息
export type PerformanceOwnershipItem = {
  allocate_id: number;
  allocate_type: PerformanceRoleType;
  ratio: number;
  amount: number; // 归属金额，单位为分
  remark?: string;
};
